let animation_frame_id = null;

export default {
  name: "BolideLoader",

  mounted() {
    // Ensure canvas exists before starting animation
    this.$nextTick(() => {
      this.start_npi_typing_loader();
    });
  },

  beforeUnmount() {
    if (animation_frame_id) {
      cancelAnimationFrame(animation_frame_id);
      animation_frame_id = null;
    }

    window.removeEventListener("resize", this._resize_canvas);
  },

  methods: {
    start_npi_typing_loader() {
      const canvas = this.$refs.npi_loader_canvas;
      const ctx = canvas.getContext("2d");

      const colors = {
        bg: "#fff",
        np: "#2f7f8f", // teal
        i: "#ff3b6e",  // pink (i only)
      };

      const resize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };

      // store reference so we can remove listener
      this._resize_canvas = resize;

      window.addEventListener("resize", resize);
      resize();

      const cx = () => canvas.width / 2;
      const cy = () => canvas.height / 2;

      const state = {
        np_text: "",
        i_visible: false,
        sub_text: "",
        phase: "type_np", // type_np → type_i → type_sub → hold → fade
        np_index: 0,
        sub_index: 0,
        opacity: 1,
        timer: 0,
      };

      const np_target = "np";
      const sub_target = "Governance Solutions";

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = colors.bg;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.save();
        ctx.globalAlpha = state.opacity;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        /* === n + p (italic, teal) === */
        ctx.font = "italic 700 96px Inter, sans-serif";
        ctx.fillStyle = colors.np;
        ctx.fillText(state.np_text, cx() - 24, cy());

        /* === i (italic, pink) === */
        if (state.i_visible) {
          ctx.fillStyle = colors.i;
          ctx.fillText("i", cx() + 44, cy());
        }

        /* === subtext (italic, teal) === */
        ctx.font = "italic 400 18px Inter, sans-serif";
        ctx.fillStyle = colors.np;
        ctx.fillText(state.sub_text, cx(), cy() + 64);

        ctx.restore();
      };

      const phase_handlers = {
        type_np() {
          if (state.np_index < np_target.length) {
            state.np_text += np_target[state.np_index];
            state.np_index += 1;
            return;
          }
          state.phase = "type_i";
        },

        type_i() {
          state.i_visible = true;
          state.phase = "type_sub";
        },

        type_sub() {
          if (state.sub_index < sub_target.length) {
            state.sub_text += sub_target[state.sub_index];
            state.sub_index += 1;
            return;
          }
          state.phase = "hold";
          state.timer = 0;
        },

        hold() {
          state.timer += 1;
          if (state.timer > 80) {
            state.phase = "fade";
          }
        },

        fade() {
          state.opacity -= 0.02;
          if (state.opacity <= 0) {
            cancelAnimationFrame(animation_frame_id);
            animation_frame_id = null;
          }
        },
      };
      const update = () => {
        const handler = phase_handlers[state.phase];
        if (handler) handler();
      };


      const frame = () => {
        update();
        draw();
        animation_frame_id = requestAnimationFrame(frame);
      };

      frame();
    },
  },
};
